import { useEffect, useState } from "react";

// True once the referenced element has scrolled above `offset` px (navbar height).
export const useScrolledPast = (ref, offset = 80) => {
  const [past, setPast] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = ref.current;
      if (el) setPast(el.getBoundingClientRect().bottom < offset);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [ref, offset]);
  return past;
};

// Index of the `course-N` section currently in the middle of the viewport.
export const useActiveSection = (count, prefix = "course-") => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    if (count === 0) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const idx = Number(entry.target.id.replace(prefix, ""));
          if (entry.isIntersecting && !Number.isNaN(idx)) setActive(idx);
        });
      },
      { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
    );
    for (let i = 0; i < count; i += 1) {
      const el = document.getElementById(`${prefix}${i}`);
      if (el) observer.observe(el);
    }
    return () => observer.disconnect();
  }, [count, prefix]);
  return active;
};
